// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"61c50026","131":"06e1c287","133":"a075edeb","248":"afd105cf","370":"db003063","453":"54292a4b","489":"1a3fe974","518":"13e595c7","605":"8937522a","673":"7374edce","731":"3531e6ae","784":"92e765d6","786":"a5b5da4b","937":"4e51c221","967":"bdfbedad","977":"523e3d17"}[chunkId] + ".chunk.js";
};